export async function editarDispositivo(idDispositivo, { ip, name, description }) {
  const url = `${process.env.REACT_APP_MICROSERVICO_IP}/cmd/devices/${idDispositivo}`;
  const data = { ip, name, description };

  console.log("Dados enviados:", data);

  const response = await fetch(url, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.text();
    throw new Error(`Erro na resposta: ${response.status} - ${errorData}`);
  }
  return response.json();
}